import * as React from "react";
import type { SVGProps } from "react";
const Component = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4804_10647)">
      <path
        d="M25.2228 19.8695C22.2558 19.8695 19.5175 20.6835 17.484 22.3141C15.4506 23.9446 14.1718 26.4215 14.1719 29.4633V29.4657V29.4682C14.1722 29.5135 14.1768 32.1956 14.1768 32.1956L14.1719 35.8433H35.9839L36.0021 32.1956C36.0021 32.1956 36.0058 30.8776 36.0071 30.3717C36.0083 29.8659 36.0132 29.4454 36.0119 29.4826V29.4728V29.4629C36.0119 26.1164 34.4712 23.6206 32.3595 22.0764C30.2478 20.5323 27.6091 19.8692 25.2247 19.8691L25.2228 19.8695ZM25.2228 21.7101C27.2568 21.7101 29.5532 22.3077 31.2695 23.5627C32.9858 24.8178 34.1694 26.6602 34.1694 29.4633C34.167 29.5961 34.1657 29.8687 34.1645 30.3644C34.1633 30.8707 34.1621 31.5315 34.1596 32.1906C34.1572 32.8463 34.1535 33.499 34.1498 34.0025H16.024C16.0216 33.499 16.0178 32.8455 16.0166 32.1906C16.0129 30.8758 16.013 29.6073 16.0117 29.4633C16.0117 26.9198 17.0003 25.0594 18.6337 23.7497C20.267 22.44 22.5944 21.7101 25.2228 21.7101Z"
        fill="#007A3F"
      />
      <path
        d="M25.2319 4.13574C21.3563 4.13574 18.1953 7.29134 18.1953 11.1627C18.1953 15.034 21.3563 18.192 25.2319 18.192C29.1074 18.192 32.2708 15.034 32.2708 11.1627C32.2708 7.29134 29.1074 4.13574 25.2319 4.13574ZM25.2319 5.97636C28.1144 5.97636 30.4302 8.28787 30.4302 11.1627C30.4302 14.0375 28.1144 16.3514 25.2319 16.3514C22.3492 16.3514 20.0359 14.0375 20.0359 11.1627C20.0359 8.28787 22.3492 5.97636 25.2319 5.97636Z"
        fill="#007A3F"
      />
      <path
        d="M13.6844 20.6006C10.9189 20.6005 8.50279 21.3686 6.77008 22.9181C5.03737 24.4676 4.05433 26.7791 4.05469 29.5808V29.5833V29.5857C4.05493 29.6346 4.05963 32.2532 4.05963 32.2532L4.07813 35.8434H11.6117H12.6326V34.0028H11.6117H5.90534C5.90289 33.5122 5.9017 32.8848 5.90048 32.2508C5.89802 30.9586 5.89676 29.6979 5.89553 29.5762C5.8964 27.1934 6.67427 25.4748 7.99739 24.2916C9.32053 23.1083 11.2564 22.4422 13.6798 22.4414C13.9537 22.4438 14.7654 22.5233 14.7654 22.5233C14.7654 22.5233 15.7021 21.405 16.1268 20.8643L15.2185 20.7229C14.713 20.6442 14.2012 20.6036 13.6894 20.6007H13.6869L13.6844 20.6006Z"
        fill="black"
      />
      <path
        d="M13.5917 6.50992C10.0958 6.48538 7.21891 9.31432 7.19546 12.8059C7.17166 16.2975 10.01 19.1651 13.506 19.1879C15.0183 19.1964 16.4773 18.6648 17.6263 17.701C17.7659 17.5841 17.8997 17.4614 18.0291 17.3323L18.4964 16.8627L17.3808 15.3794L16.8873 15.891C16.7969 15.9847 16.5433 16.2084 16.4447 16.291C15.6287 16.9754 14.5906 17.3538 13.516 17.3473C11.0128 17.331 9.01907 15.3128 9.03608 12.8183C9.05289 10.3239 11.0737 8.33291 13.5769 8.35047C14.3401 8.35538 15.0912 8.55309 15.7563 8.92604L16.5586 9.37728C16.5586 9.37728 17.1341 7.87357 17.2151 7.64121L16.6564 7.32156C15.7201 6.79653 14.6655 6.51763 13.5917 6.50992Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_4804_10647">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(4.02344 3.9751)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default Component;
